export default __webpack_public_path__ + "static/media/Rectangle_20.d973d13d.png";